<div class="verify-email-wrapper">
  <mat-card class="verify-email-card">
    <mat-card-header class="verify-email-header">
      <div class="logo" role="img" aria-label="Damotech"></div>
      <div class="title">{{ 'verifyemail.title' | translate }}</div>
      @if (!formSuccess()) {
        <div class="description">{{ 'verifyemail.description' | translate }}</div>
        <div class="description">{{ 'verifyemail.subdescription' | translate }}</div>
      }
    </mat-card-header>

    <div class="verify-email-content">
      <mat-card-content>
        @if (formSuccess()) {
          <p class="success-message">{{ successMessage() }}</p>
        } @else {
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="fields">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'verifyemail.password.title' | translate }}</mat-label>
                <input matInput type="password" formControlName="password" autocomplete="new-password" />
                <mat-icon matPrefix>lock</mat-icon>
                @if (form.get('password')?.hasError('required') && form.get('password')?.touched) {
                  <mat-error>{{ 'verifyemail.password.required' | translate }}</mat-error>
                } @else if (form.get('password')?.touched && form.get('password')?.invalid) {
                  <mat-error>{{ 'verifyemail.password.complexity' | translate }}</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'verifyemail.password.repeat.title' | translate }}</mat-label>
                <input matInput type="password" formControlName="passwordRepeat" autocomplete="new-password" />
                <mat-icon matPrefix>lock</mat-icon>
                @if (form.get('passwordRepeat')?.hasError('required') && form.get('passwordRepeat')?.touched) {
                  <mat-error>{{ 'verifyemail.password.repeat.required' | translate }}</mat-error>
                } @else if (form.get('passwordRepeat')?.touched && form.get('passwordRepeat')?.hasError('match')) {
                  <mat-error>{{ 'verifyemail.password.repeat.match' | translate }}</mat-error>
                }
              </mat-form-field>

              @if (errorMessage()) {
                <p class="error-message">{{ errorMessage() }}</p>
              }
            </div>

            <button
              mat-flat-button
              color="primary"
              type="submit"
              class="btn"
              [disabled]="loading()"
            >
              @if (loading()) {
                <mat-spinner diameter="20" />
              } @else {
                {{ 'verifyemail.submit' | translate }}
              }
            </button>
          </form>
        }
      </mat-card-content>

      <mat-card-actions class="verify-email-actions">
        @if (redirectUrl() && formSuccess()){
          <button mat-flat-button color="primary" type="button" class="btn" (click)="proceedAfterReset()">
            {{ 'verifyemail.continue' | translate }}
          </button>
        }
        <div class="back">
          <a mat-button [routerLink]="['../', DAMO_AUTH_PATHS.SIGN_IN]" class="back-to-sign-in-link">
            {{ 'verifyemail.backtosignin' | translate }}
          </a>
        </div>
      </mat-card-actions>
    </div>
  </mat-card>
</div>
